import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import BlogService from '../../services/BlogService';
import { Spin, Empty } from 'antd'; 

const BlogDetailContainer = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            fetchBlogDetail();
        }
    }, [id]);

    const fetchBlogDetail = async () => {
        try {
            setLoading(true);
            const response = await BlogService.getBlogById(id);
            setBlog(response?.data[0] || response); 
        } catch (error) {
            console.error("Error fetching blog detail:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div style={{ padding: "100px", textAlign: "center" }}><Spin size="large" /></div>;
    }

    if (!blog) {
        return <div style={{ padding: "100px" }}><Empty description="Blog Not Found" /></div>;
    }

    return (
        <section className="blog-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-7 blog-details-body" style={{ width: "100%" }}>
                        <div className="blog-details-inner">
                            <div className="post-content">
                                <figure className="block-gallery mb-0">
                                    <ul className="blocks-gallery-grid">
                                        <li className="blocks-gallery-item mb-0 me-0">
                                            <figure>
                                                {/* DYNAMIC IMAGE */}
                                                <img 
                                                    src={blog.imageUrl || "images/blog/md-4.jpg"} 
                                                    alt={blog.title} 
                                                    className="block-image" 
                                                    style={{ width: '100%', 
                                                    height: "500px",
                                                    borderRadius: '8px' }}
                                                />
                                            </figure>
                                        </li>
                                    </ul>
                                </figure>

                                <div className="post-header">
                                    {/* DYNAMIC DATE & TAG */}
                                    <div className="post-date">
                                        {new Date(blog.publishedDate).toLocaleDateString('en-US', {
                                            month: 'long',
                                            day: 'numeric',
                                            year: 'numeric'
                                        })} 
                                        {blog.tag && <span style={{ marginLeft: '10px' }} className="badge bg-primary">{blog.tag}</span>}
                                    </div>
                                    {/* DYNAMIC TITLE */}
                                    <h1 className="post-title">{blog.title}</h1>
                                </div>

                                <div className="fulltext">
                                    {/* DYNAMIC CONTENT (Rendering HTML Safely) */}
                                    <div 
                                        className="content-area"
                                        dangerouslySetInnerHTML={{ __html: blog.content }} 
                                    />

                                    {/* Static sections start here - keep or remove as needed */}
                                    <div className="post-footer" style={{ marginTop: '40px' }}>
                                        <div className="post-share">
                                            <ul className="share-list">
                                                <li>Share:</li>
                                                <li className="facebook"><a href="#">Facebook</a></li>
                                                <li className="twitter"><a href="#">Twitter</a></li>
                                                <li className="linkedin"><a href="#">Linkedin</a></li>
                                            </ul>
                                        </div>
                                    </div>

                                    {/* Author Section */}
                                    {/* <div className="author-div">
                                        <div className="author">
                                            <img alt="img" src="images/blog/author-2.png" className="avatar" />
                                        </div>
                                        <div className="author-block">
                                            <h5 className="author-name">Admin</h5>
                                            <p className="author-intro">Expert insights into the educational landscape and digital transformation.</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogDetailContainer;